import React from 'react';
import classnames from 'classnames';
import { Dialog, DialogContentWrapper, DialogTitle, DialogDescription, DialogFooter, SwagButton } from '@ezetech/swag-space-x';
import css from './space-styles-content-popup.scss';
export const SpaceStyledContentPopup = props => {
  const {
    open,
    title,
    content,
    continueBtnText = 'Continue',
    cancelBtnText = 'Cancel',
    dialogWrapperClassName,
    contentWrapperClassName,
    isContinueDisabled,
    onCloseClick,
    onConfirmClick
  } = props;
  return /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    onOpenChange: onCloseClick
  }, /*#__PURE__*/React.createElement(DialogContentWrapper, {
    className: classnames(css.dialogContentWrapperClassName, dialogWrapperClassName),
    overlayClassName: css.dialogOverlayClassName
  }, /*#__PURE__*/React.createElement(DialogTitle, null, title), /*#__PURE__*/React.createElement(DialogDescription, {
    className: contentWrapperClassName
  }, content), /*#__PURE__*/React.createElement(DialogFooter, {
    className: css.footer
  }, /*#__PURE__*/React.createElement(SwagButton, {
    type: "outlined",
    onClick: onCloseClick
  }, cancelBtnText), /*#__PURE__*/React.createElement(SwagButton, {
    type: "primary",
    disabled: isContinueDisabled,
    onClick: onConfirmClick
  }, continueBtnText))));
};